import { getAPI } from "@/axios-api";


export const updateUserPhone = async (userId, payload) => {
  try {
    const response = await getAPI.patch(`accounts/users/manager/${userId}/`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating user phone:', error);
    throw error;
  }
};